import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './UsernameScreen.css';
import { logEvent } from '../../utils/Logger';

const UsernameScreen: React.FC = () => {
  const [username, setUsername] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const storedUsername = localStorage.getItem('username');
    if (storedUsername) {
      navigate('/posts');
    }
  }, [navigate]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (username.trim()) {
      localStorage.setItem('username', username.trim());
      logEvent('username_submit', username.trim(), window.location.href);
      navigate('/posts');
    }
  };

  return (
    <div className="username-screen">
      <div className="username-container">
        <h1>Welcome</h1>
        <p>Please enter your username to continue</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter your username"
            className="username-input"
          />
          <button type="submit" className="next-button">Next</button>
        </form>
      </div>
    </div>
  );
};

export default UsernameScreen;